import React from 'react';
import { getPlanStyle } from '../../utils/userDirectoryFilters';

export default function PlanCell({ plan }) {
  if (!plan) return <span style={{ color: '#94A3B8', fontSize: 12 }}>—</span>;

  const pc = getPlanStyle(plan.tierSlug || plan.name);
  const priceStatus = [plan.priceLabel, plan.statusLabel].filter((x) => x && x !== '—').join(' · ');

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 3, minWidth: 120 }}>
      <span
        style={{
          fontSize: 11,
          fontWeight: 600,
          ...pc,
          padding: '3px 9px',
          borderRadius: 99,
          alignSelf: 'flex-start',
        }}
      >
        {plan.name || 'Free Plan'}
      </span>
      {priceStatus && (
        <span style={{ fontSize: 11, color: '#64748B', lineHeight: 1.3 }}>{priceStatus}</span>
      )}
      {plan.renewalLabel && plan.renewalLabel !== '—' && (
        <span style={{ fontSize: 10, color: '#94A3B8' }}>{plan.renewalLabel}</span>
      )}
    </div>
  );
}
